import { TVacancyPosition } from "../store/vacancy/types";

export interface Option {
  label: string;
  value: string | number;
  rating?: number;
}

// Timeframe Type
export type Timeframe = {
  id: number;
  date: [Date | null, Date | null] | null;
  start_time: string;
  end_time: string;
  created_at?: string;
};

export interface TVacancyFormValues {
  isEdit: boolean;
  created_at: string | null;
  centre_id: number | null;
  timeline_type: string;
  timeframes: Timeframe[];
  position_uuids: string[];
  alternate_position_legacy: string;
  visibility_type: string;
  selected_candidate_id: number | null;
  // preferred_candidate_uuids: Array<String>;
  response_timeframe_check: boolean | null;
  response_timeframe: number;
  all_response_timeframe_check: boolean | null;
  all_response_timeframe: number;
  selection_method: string | number;
  allowance: number | null;
  allowance_amount: number | null;
  shift_notes: string;
}

export enum VACANCY_START_AVAILABILITY {
  NOW = "now",
  WITHIN_24_HOURS = "within_24_hours",
  FUTURE_DATE = "custom",
}

export enum VACANCY_CANDIDATE_VISIBILITY {
  ANY_CANDIDATE = "any_candidate",
  PREFERRED_CANDIDATES = "preferred_candidates",
  SELECTED_CANDIDATE = "selected_candidate",
}

export enum VACANCY_SELECTION_METHOD {
  FIRST_COME_FIRST_SERVED = "first_come",
  MANUAL_SELECTION = "manual_selection",
}
export enum CancelCaseType {
  SIMPLE = "SIMPLE", // not accepted
  ACCEPTED_24H_PLUS = "ACCEPTED_24H_PLUS",
  ACCEPTED_24H_LESS = "ACCEPTED_24H_LESS",
}
// TimeOption type
export type TimeOption = {
  label: string;
  value: string;
};

export const formatPositionName = (positionList: TVacancyPosition[]) => {
  if (positionList?.length > 0) {
    positionList?.map((item: any) => {});
  }
};

export const stepsInMyProfileStage = () => {
  return [
    {
      stage_number: 1,
      stage_name: "id_verification",
    },
    {
     stage_number: 1,
      stage_name: "personal_details",
    },
    {
      stage_number: 1,
      stage_name: "qualification",
    },
    {
      stage_number: 1,
      stage_name: "jobpreference",
    },
    {
      stage_number: 1,
      stage_name: "online_interview",
    },
    {
      stage_number: 2,
      stage_name: "compliance_check",
    },
    {
      stage_number: 3,
      stage_name: "tfn_declaration",
    },
    {
      stage_number: 3,
      stage_name: "superannuation",
    },
    {
      stage_number: 3,
      stage_name: "contract",
    },
    {
      stage_number: 3,
      stage_name: "bank_account",
    },
    {
      stage_number: 3,
      stage_name: "next_of_kin",
    }
  ];
};

export type TSelectCandidateForVacancyPayload = {
  vacancy_id: number;
  candidate_id: number;
}

export type TBlockUnBlockCandidatePayload = {
  action: string;
  user_id: number;
  reason?: string | null
}

export const profileSectionTitle =  {
  "1" : "Stage 1: Personal Details & Interview",
  "2" : "Stage 2: Compliance Checks",
  "3" : "Stage 3: Documents & Contract",
} 

export const timesheetFilterOptions = [
  { label: "Candidate", value: "first_name" },
  { label: "Vacancy", value: "centre" },
  { label: "Centre", value: "centre" },
  { label: "Job Timeframe", value: "time_frame" },
  { label: "Position Type", value: "position_name" },
  { label: "Requested Timeframe", value: "timeframe" },
  { label: "Posted", value: "created_at" },
  { label: "Applied", value: "applied_at" },
  { label: "Accepted", value: "accepted_at" },
]

/**
 * Formats allowance value to display as currency
 * @param allowance - The allowance amount (number or undefined)
 * @returns Formatted string like "$23.00" or "$0.00"
 */
export const formatAllowance = (allowance?: number, hideDecimals: boolean = false): string => {
  if (typeof allowance === 'number' && !isNaN(allowance) && allowance > 0) {
    if (hideDecimals) {
      return `$${Math.round(allowance)}`;
    }
    return `$${allowance.toFixed(2)}`;
  } else {
    return '-';
  }
};



/**
 * Formats a given Date object into a string with the format "yyyy-MMM-dd".
 * Converts the date to AEST/AEDT (Australia/Sydney timezone) before formatting.
 *
 * @param date - The Date object to format, or null.
 * @returns  28 Jul 2025 The formatted date string if a date is provided, otherwise an empty string.
 */
export const formatDate = (date: Date | null) => {
  if (!date) return "";
  
  // Convert to AEST/AEDT (Australia/Sydney timezone)
  const aestDate = new Date(date.toLocaleString("en-US", { timeZone: "Australia/Sydney" }));
  
  const day = aestDate.getDate();
  const month = aestDate.toLocaleDateString("en-US", { month: "short" });
  const year = aestDate.getFullYear();

  return `${day} ${month} ${year}`;
};
